<template>
    <div v-if="rebookableFee?.Amount > 0" class="price-section">
        <PriceSpecificationRow
            :price="rebookableFee"
            :description="t({ key: 'checkout.flexible_ticket' })"
            :readMore="{
                title: t({ key: 'checkout.flexible_ticket' }),
                description: t({ key: 'checkout.flexible_ticket_read_more' }),
            }" />
        <Divider color="lightGrey" bottomMargin="xl" topMargin="xl" thickness="1" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { Money } from '@libs/money/money.interfaces';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'PriceSpecificationRebookableFee',
        components: {
            Divider,
            PriceSpecificationRow,
        },
        methods: { t },
        props: {
            rebookableFee: {
                type: Object as PropType<Money>,
                required: true,
            },
        },
    });
</script>
